import React from 'react'
import { AuthContextType } from '../interfaces'

/**
 * A helper to create a Context and Provider with no upfront default value, and
 * without having to check for undefined all the time.
 */
export function createCtx<A extends {} | null>() {
  const ctx = React.createContext<A | undefined>(undefined)
  function useCtx() {
    const c = React.useContext(ctx)
    if (c === undefined)
      throw new Error('useCtx must be inside a Provider with a value')
    return c
  }
  return [useCtx, ctx.Provider, ctx.Consumer] as const // 'as const' makes TypeScript infer a tuple
}
/**
 * The AuthContext that allow access to Token object and fetchRefreshToken method
 */

export const [
  useAuthContext,
  AuthContextProvider,
  AuthContextConsumer
] = createCtx<AuthContextType>()
